import { VStack } from '@/components/sgBootstrapReactWrapper';
import clsx from 'clsx';
import { useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Field } from './Field';
import { type PositionType, type Template } from './template';
import { isDefined } from '@/utils/assertions';

type Props = {
  position: PositionType;
  template: Template;
};

export function PositionDetailsDrawerBody({ position, template }: Props) {
  let tabs = template.tabs;
  const fieldsForTab = useMemo(
    () => Object.fromEntries(tabs.map(({ id, fields: fieldNames }) => [id, fieldNames])),
    [tabs],
  );

  const [selectedTab, setSelectedTab] = useState<string>(tabs[0]?.id ?? '');

  const buildTabHead = (id: string) => (
    <li key={id} data-e2e={`operation-details-body-tab-${id}`} className="nav-item">
      <div className={clsx(selectedTab === id && 'active', 'nav-link user-select-none fw-semibold fs-14 py-12px')}
        onClick={() => setSelectedTab(id)} >
        <FormattedMessage id={`operation.drawer.tab.${id}`} />
      </div>
    </li>
  )

  return (isDefined(tabs) && tabs.length > 0) && (
    <VStack flex="expand">
      <ul className="nav nav-underline nav-md ps-24px flex-grow-0">
        {tabs.map(({ id }) => buildTabHead(id))}
      </ul>

      <VStack flex="expand" className="border-top p-24px" verticalAlignment="start">
        {fieldsForTab[selectedTab].map((fieldSpec) => (
          <Field
            key={typeof fieldSpec === 'string' ? fieldSpec : fieldSpec.fieldName}
            fieldSpec={fieldSpec}
            position={position}
            positionType={template.type}
          />
        ))}
      </VStack>
    </VStack>
  );
}
